import React, { useEffect } from "react";
import Layout from '../components/layout/Layout';
import bioPhoto from '../assets/images/Bio.png';

export default function Biography() {

  // Scroll to top when component loads
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
    
  return (
    <Layout>
      <div className="pt-32 pb-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-3 gap-12">
            {/* Left column - Text content */}
            <div className="md:col-span-2">
              <h1 className="text-6xl md:text-8xl font-light mb-12">Biography</h1>
              
              <div className="space-y-8 text-lg text-gray-700 leading-relaxed">
                <h2 className="text-3xl font-light mt-12 mb-6">Early Life</h2>
                <p>
                  Erika Louise Hubbard started playing the violin at age 4 with Jessica Guideri of the Fry Street Quartet in Logan and later Rebecca McFaul also of the Fry Street Quartet. She began her piano lessons two years later and is currently studying with Professor Gary Amano at Utah State University.
                </p>
                <p>
                  She is a winner of the Utah Symphony youth guild in violin 2012. She has won numerous first prize awards at the USU Piano Festival Competition over the last several years. She was a winner of the Utah Symphony Youth Guild competition for piano 3 times, and has been a finalist for the Utah Symphony Salute to Youth Auditions the past three years.
                </p>
                <p>
                  At age 13, Erika continues to divide her music studies and practice time between piano and violin, and now studies violin with Deborah Moench. She is on full scholarship as a member of the Gifted Music School and Orchestra in Salt Lake City directed by Eugene Watanabe. Erika also performs with the Rocky Mountain Strings group.
                </p>
                <p>
                  In addition to music, Erika travels throughout Utah on a competitive soccer team. For the past two years, she has been home schooling to accommodate all her trips from Logan to Salt Lake.
                </p>
                
                <h2 className="text-3xl font-light mt-12 mb-6">Education</h2>
                <p>
                  Your educational background, degrees, certifications...
                </p>
                
                <h2 className="text-3xl font-light mt-12 mb-6">Career Journey</h2>
                <p>
                  Your professional journey, key milestones, experiences...
                </p>
                
                <h2 className="text-3xl font-light mt-12 mb-6">Philosophy & Approach</h2>
                <p>
                  Your work philosophy, what drives you, your methodology...
                </p>
                
                <h2 className="text-3xl font-light mt-12 mb-6">Personal Interests</h2>
                <p>
                  Hobbies, interests outside of work, what you're passionate about...
                </p>
              </div>
            </div>

            {/* Right column - Image */}
            <div className="md:col-span-1">
             <img 
                src={bioPhoto} 
                alt="Erika Hubbard" 
                className="w-full h-auto rounded-lg shadow-xl mt-100"
              />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
